import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, ButtonBase, Dialog, DialogContent, DialogTitle, Tooltip, Typography } from '@mui/material';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useAuth } from '../../../auth/AuthProvider';
import { roleLabels } from '../../../configs/profile';
import AccessSelectionForm from '../../../components/AccessSelectionForm';
import { t } from '../../../i18n';

export default function ContextSelector() {
    const { role, roles } = useAuth();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    if (!role) return null;
    const details = (
        <>
            <BusinessOutlined sx={{ flexShrink: 0, fontSize: 21 }} />
            <Box sx={{ display: { xs: 'none', md: 'block' }, minWidth: 0, textAlign: 'left' }}>
                <Typography variant="body2" noWrap sx={{ color: 'primary.main', fontWeight: 500 }}>
                    {role.account.name || t('Clínica')}
                </Typography>
                <Typography variant="caption" noWrap sx={{ display: 'block' }}>{t(roleLabels[role.name] || role.name)}</Typography>
            </Box>
        </>
    );
    return (
        <>
            {roles.length > 1 ? <Tooltip title={t('Mudar clínica e perfil')}>
                <ButtonBase aria-label={t('Mudar clínica e perfil')} onClick={() => setOpen(true)}
                    sx={{ display: 'flex', gap: 1, p: 1, borderRadius: 2, maxWidth: 270, color: 'accent.main', '&:hover': { bgcolor: 'secondary.200' } }}>
                    {details}<ExpandMore fontSize="small" />
                </ButtonBase>
            </Tooltip> : <Tooltip title={role.account.name || t('Clínica')}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, maxWidth: 250, color: 'accent.main' }}>{details}</Box>
            </Tooltip>}
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" aria-labelledby="context-dialog-title">
                <DialogTitle id="context-dialog-title">{t('Mudar clínica e perfil')}</DialogTitle>
                <DialogContent>
                    <AccessSelectionForm warnOnSwitch onCancel={() => setOpen(false)} onSelected={() => {
                        setOpen(false);
                        navigate('/', { replace: true });
                    }} />
                </DialogContent>
            </Dialog>
        </>
    );
}
